import { BRANDS } from '.';
import { FlightPartyComposition, RoomComposition } from './composition.service';
import { PRODUCT_TYPES } from '../../types/criteria';
import tokens from '@vaad1st/shared.design-tokens/json/variables.json';

export const APP_CONSTANTS = {
	BASE: '/search-experience',
	ASSETS_PATH: '/assets/public'
};

export const STATE_DEFAULTS = {
	BRAND: BRANDS.VAA,
	OPEN: false,
	CLOSABLE: true,
	HIDE_TOGGLE: false,
	FLOAT: false,
	FULLSCREEN: false
};

export const DATE_FORMATS = {
	URL_DATE: 'yyyy-MM-dd',
	DISPLAY_DATE: 'dd MMM, yyyy',
	FIELD_DISPLAY_DATE: 'dd MMM',
	CALENDAR_DAY: 'd',
	CALENDAR_MONTH: 'MMMM'
};

export const CABIN_CLASSES = {
	ALL_CABINS: {
		code: '',
		name: 'All Cabins',
		displayName: 'All cabins'
	},
	ECONOMY: {
		code: 'VSLT',
		name: 'Economy',
		displayName: 'Economy'
	},
	PREMIUM: {
		code: 'VSPE',
		name: 'Premium',
		displayName: 'Premium'
	},
	UPPER: {
		code: 'VSUP',
		name: 'Upper Class',
		displayName: 'Upper Class'
	}
};

export const TRIP_TYPES = {
	ONE_WAY: {
		value: 'ONE_WAY',
		name: 'One way',
		displayName: 'One way trip'
	},
	ROUND_TRIP: {
		value: 'ROUND_TRIP',
		name: 'Round trip',
		displayName: 'Round trip'
	},
	MULTICITY: {
		value: 'MULTICITY',
		name: 'Multi-city',
		displayName: 'Multi-city'
	}
};

export const PAYMENT_TYPES = {
	MONEY: {
		value: '',
		name: 'Money',
		displayName: 'Pay with money'
	},
	POINTS: {
		value: 'PAY_WITH_POINTS',
		name: 'Points plus money',
		displayName: 'Pay with points plus money'
	}
};

export const NOTCH_HEIGHT = tokens.spacing_64px.value; // 64px

export const TICKER_HEIGHTS = {
	default: '104px',
	small: '122px'
};

export const BACKGROUND_HEIGHTS = {
	default: {
		closed: '148px',
		opened: '148px'
	},
	desktop: {
		closed: TICKER_HEIGHTS.small,
		opened: `100%`
	}
};

export const DEFAULT_PASSENGERS: FlightPartyComposition = {
	adults: 1,
	teens: 0,
	children: 0,
	infants: 0
};

export const DEFAULT_ROOMS: RoomComposition[] = [
	{
		adults: 2,
		childAges: [],
		infants: 0
	}
];

// Just copied from Storybook for now
export const Z_INDEX_TOKENS = {
	base: 2000,
	header: 2100,
	alertBanner: 2200,
	blanket: 2300,
	modal: 2400,
	tooltip: 2500
};

// TODO: revisit once we've solidified stacking tokens from CL
// We have to start at 1007 to ensure we sit above header and footer...!
export const Z_INDICES = {
	base: Z_INDEX_TOKENS.blanket + 1,
	popover: Z_INDEX_TOKENS.blanket + 1,
	popverBlanket: Z_INDEX_TOKENS.blanket
};

export const EVENTS = {
	flyoutOpen: 'OPEN_FLYOUT',
	flyoutClose: 'CLOSE_FLYOUT',
	searchPanelBrandChange: 'SEARCH_PANEL_BRAND_CHANGE'
};

export const DATEPICKER_ERROR_MESSAGE = {
	noSelection: 'You need to add departure and return dates',
	oneWay: 'Please enter your flight date',
	range: 'When are you coming back?',
	hotelOnlyRange: 'When are you checking in and out?',
	duration: 'Maximum 28 nights',
	backInTime: 'Your departure date needs to be on or after your previous flight'
};

export const DATE_MODIFIERS = {
	defaultStartDays: 0,
	defaultEndMonths: 12,
	holidaysStartDays: 3,
	holidaysEndMonths: 24
};

export const TYPEAHEAD_MESSAGES = {
	noResultsMatch: `Oops! We don’t travel to any destinations that match those details.`,
	historyTitle: 'Recent',
	locationPlaceholder: 'e.g. New York',
	requiredOrigin: 'Please enter where you are flying from',
	requiredDestination: 'Please enter a destination'
};

export const MULTICITY_CONFIG = {
	minRows: 2,
	maxRows: 6
};

export const COOKIES = {
	MULTICITY: 'MULTICITY_ENABLED',
	FLIGHT_HOTEL: 'FLIGHT_HOTEL_AB_TEST',
	// Set by the browse-nextjs app on regional pages and read here to resolve locale-specific placeholder copy.
	NEXT_LOCALE: 'NEXT_LOCALE'
};

export const TRACKING_CTA_PARAMS = {
	HOLIDAYS: 'AbTest_SP_Holidays',
	FLIGHT_HOTEL: 'AbTest_SP_FandH',
	HOTEL_ONLY: 'AbTest_SP_HotelOnly',
	CAR_ONLY: 'AbTest_SP_CarOnly',
	FLYDRIVE: 'AbTest_SP_FlyDrive',
	MULTIDEST: 'AbTest_SP_Multidest'
};

export const DEFAULT_DURATIONS = {
	[PRODUCT_TYPES.CAR]: 7
};
